/**
 * OPS-STAB-003 — execution ergonomics constants (both shells).
 */

export const EXECUTION_UX = {
  /** Debounced patient/search (ms) */
  SEARCH_DEBOUNCE_MS: 280,
  /** Queue poll in production cashier mode */
  QUEUE_REFRESH_MS: 12000,
  /** Defer non-critical timeline/history fetches */
  DEFER_PANEL_MS: 400,
  /** Max queue rows before virtualization recommended */
  VIRTUALIZE_QUEUE_THRESHOLD: 80,
  /** Attribute for keyboard queue navigation */
  QUEUE_ROW_ATTR: 'data-queue-idx',
  /** CSS class names (shells map to their design system) */
  CLASS: {
    STICKY_ACTION_DOCK: 'op-execution-sticky-dock',
    STICKY_ACTION_TOP: 'op-execution-sticky-top',
    COMPACT_QUEUE_ROW: 'op-execution-queue-row',
    ZERO_SCROLL_WORKFLOW: 'op-execution-zero-scroll',
    PAYMENT_FIRST: 'op-execution-payment-first',
    SCAN_FIRST: 'op-execution-scan-first',
  },
};

export const EXECUTION_HINTS = {
  BILLING: 'F2 patient · F4 payment · F6 print · F8 refresh · ↑↓ queue · Ctrl+Enter pay',
  PHARMACY: 'F3 scan · Enter fulfill · F6 print · F8 refresh',
  LAB: 'F2 accession · Enter verify · F6 print · F8 refresh · ↑↓ queue',
  RADIOLOGY: 'F2 search · Enter verify · F6 print · F8 refresh',
  DISCHARGE: 'F4 settlement · Ctrl+Enter discharge · F8 refresh',
  ALERTS: 'F8 refresh · ↑↓ queue · Enter open',
};

/**
 * Scroll element into view for queue keyboard nav.
 */
export function scrollQueueRowIntoView(index, attr = EXECUTION_UX.QUEUE_ROW_ATTR) {
  if (typeof document === 'undefined') return;
  document.querySelector(`[${attr}="${index}"]`)?.scrollIntoView({ block: 'nearest', behavior: 'auto' });
}

/** Focus first payment amount field (F4). */
export function focusPaymentAmount() {
  if (typeof document === 'undefined') return;
  const el = document.querySelector('[data-payment-amount="true"]');
  el?.focus?.();
  el?.select?.();
}

export function focusScanInput() {
  if (typeof document === 'undefined') return;
  document.querySelector('[data-scan-input="true"]')?.focus?.();
}
